module.exports = __webpack_public_path__ + "img/bgtop.01a3c226.jpg";